let analyticsService = null;

//welcome-screen handleClick skin-quiz
export const handleClick = (event: Event) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    window['AIBA']['utils'].getNextJourney('welcome_screen');
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;
    analyticsService?.registerEvent('event2', event);
  }
};

//welcome-screen handleOnLoad
export const handlOnLoad = data => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;

    // analyticsService?.registerEvent('event1', { page: 'aiba welcome screen' });

    return data;
  }
};

export const handleToggleAccordian = (event: any) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers?.analyticsService;
    analyticsService?.registerEvent('event2', event, { target: { textContent: 'accordian toggled' } });
  }
};
